import {Dialog, DialogContent, DialogFooter} from '@/shadcn_components/ui/dialog';
import {FileInput, RenderPreviewOptions} from '@/components/refinedev/FileInput';
// import {DialogStateProps} from 'hooks/useDialogState';
import {useEffect, useMemo, useState} from 'react';
import {apiClient} from '@/lib/client';
// import {DocumentItemView} from './components';
import {Button} from '@/shadcn_components/ui/button';
import Spinner from '@/components/basic/Spinner';
import {FormProvider, useForm} from 'react-hook-form';
import {UseDialogStateReturn} from '@/hooks/useDialogState';
import {createColumnHelper, getCoreRowModel, useReactTable} from '@tanstack/react-table';
import {CheckCircleIcon, XCircleIcon} from 'lucide-react';
import {DeleteIconButton} from '@/components/basic/buttons';
import {DialogTitle} from '@radix-ui/react-dialog';
import {DocumentableObject} from './types';
import {DataTableColumnHeader} from '@/components/data-table/data-table-column-header';
import formatter from '@/lib/formatter';
import {DataTable} from '@/components/data-table/data-table';
import {DepartmentSelectInput} from '../departments/components/department-select-input';
import {apiService} from '@/lib/ApiService';
import {de} from 'date-fns/locale';

type UploadStatus = 'wait' | 'uploading' | 'completed' | 'error';

type DocumentUploadDialogProps = {
  dialogState: UseDialogStateReturn;
  onSuccess?: () => void;
} & Partial<DocumentableObject> & {tags?: string};

const DocumentUploadDialog = (props: DocumentUploadDialogProps) => {
  const {dialogState, onSuccess, mediable_type, mediable_id} = props;

  const [uploadStatus, setUploadStatus] = useState<UploadStatus[]>([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<any>(undefined);
  // const refresh = useRefresh();
  const useFormResults = useForm({
    defaultValues: {test_files: []},
  });
  const {handleSubmit} = useFormResults;

  async function onSubmit(data) {
    console.log('submit', data);
    const {test_files} = data;
    // const us = test_files.map(v => 'wait');
    // setUploadStatus(us);
    let fileIndex = 0;
    try {
      // set status flags
      setUploading(true);
      setError(undefined);

      // loop
      for (fileIndex = 0; fileIndex < test_files.length; fileIndex++) {
        if (uploadStatus[fileIndex] === 'completed') continue;
        const f = test_files[fileIndex];
        setUploadStatus(
          test_files.map((v, j) => {
            if (j < fileIndex) return 'completed';
            if (j === fileIndex) return 'uploading';
            return 'wait';
          }),
        );

        const params: any = {};
        if (mediable_type && mediable_id) {
          params[mediable_type + '_id'] = String(mediable_id);
        } else if (data.department_id) {
          params['department_id'] = String(data.department_id);
        }

        await apiService.documents.upload(f.rawFile, params);

        // const formdata = new FormData();
        // formdata.append('file', f.rawFile);
        // if (mediable_type && mediable_id) {
        //   formdata.append(mediable_type + '_id', String(mediable_id));
        // } else if (data.department_id) {
        //   formdata.append('department_id', String(data.department_id));
        // }

        // await apiClient.post('/api/upload/document', formdata, {
        //   headers: {
        //     'Content-Type': 'multipart/form-data',
        //   },
        //   withCredentials: true,
        // });
        // await sleep(2000); //simulate upload
        // if (fileIndex == 1) throw 'Test error';//test error
      }
      // all complete
      setUploadStatus(test_files.map(v => 'completed'));
      onSuccess?.();
      dialogState.closeDialog();
      // refresh();
    } catch (err: any) {
      console.error('Upload error', err);
      setError(err.data || err);
      setUploadStatus(
        test_files.map((v, j) => {
          if (j < fileIndex) return 'completed';
          if (j === fileIndex) return 'error';
          return 'wait';
        }),
      );
    } finally {
      setUploading(false);
    }
  }

  /// when open, reset uploading status
  useEffect(() => {
    if (dialogState.open) {
      setUploadStatus([]); //open clear status
      useFormResults.reset();
    }
  }, [dialogState.open]);

  return (
    <Dialog open={dialogState.open} onOpenChange={dialogState.closeDialog}>
      <DialogContent className="overflow-y-auto max-h-[70vh] max-w-7xl">
        <FormProvider {...useFormResults}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogTitle>Tải file lên</DialogTitle>
            {!mediable_type && !mediable_id && (
              <DepartmentSelectInput
                source="department_id"
                label="Tài liệu của phòng ban"
                className="w-72"
              />
            )}
            <FileInput
              source="test_files"
              label=""
              multiple={true}
              renderPreview={(files, options) => renderPreview(files, uploadStatus, options)}
              dropzonePrompt={
                <>
                  {/* <PhotoIcon className="w-8 h-8" /> */}
                  <h3 className="mt-2 text-sm font-medium text-gray-900">
                    Kéo thả vào đây hoặc nhấn để chọn file tải lên
                  </h3>
                  <p className="mt-1 text-xs text-gray-500">PDF, DOC, DOCX, XLS, XLSX, TXT, CSV</p>
                </>
              }
            />

            {!uploading ? (
              <DialogFooter className="mt-2">
                <div className="grow text-red-500">{error?.message || JSON.stringify(error)}</div>
                <Button
                  type="button"
                  variant="ghost"
                  color="red"
                  onClick={e => {
                    e.stopPropagation();
                    dialogState.closeDialog();
                  }}
                  className="mr-1">
                  <span>Hủy bỏ</span>
                </Button>
                <Button type="submit">
                  <span>Tải lên</span>
                </Button>
              </DialogFooter>
            ) : (
              <DialogFooter className="mt-2">
                <Spinner className="w-12 h-12" />
              </DialogFooter>
            )}
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};

function renderPreview(files, uploadStatus, options) {
  return <DocumentListPreview files={files} uploadStatus={uploadStatus} options={options} />;
}

const columnHelper = createColumnHelper<any>();

function ActionAndStatusCell({info, uploadStatus, options}) {
  const {row} = info;
  const {original: file} = row;
  const index = row.index;
  const status = uploadStatus[index];

  return (
    <div className="flex items-center justify-center">
      {status === 'uploading' ? (
        <Spinner className="w-6 h-6" />
      ) : status === 'completed' ? (
        <CheckCircleIcon className="w-6 h-6 text-green-500" />
      ) : status === 'error' ? (
        <XCircleIcon className="w-6 h-6 text-red-500" />
      ) : (
        <></>
      )}
      {status !== 'uploading' && status !== 'completed' && (
        <DeleteIconButton
          onClick={() => {
            console.log('click remove', file);
            options?.removeFile?.(file);
          }}
        />
      )}
    </div>
  );
}

function DocumentListPreview(props: {
  files: any[];
  uploadStatus: UploadStatus[];
  options?: RenderPreviewOptions;
}) {
  const {files, uploadStatus, options} = props;

  const file_preview_columns = useMemo(
    () => [
      columnHelper.accessor((row, index) => index + 1, {
        id: 'index',
        meta: {label: 'STT'},
        header: ({column}) => <DataTableColumnHeader column={column} />,
        cell: info => info.getValue(),
      }),

      columnHelper.display({
        id: 'title',
        meta: {label: 'Tên file'},
        header: ({column}) => <DataTableColumnHeader column={column} />,
        cell: info => (
          <a
            href={info.row.original.src}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-500 hover:underline">
            {info.row.original.title}
          </a>
        ),
      }),

      columnHelper.display({
        id: 'size',
        meta: {label: 'Kích thước'},
        header: ({column}) => <DataTableColumnHeader column={column} />,
        cell: info => formatter.formatFileSize(info.row.original.rawFile.size),
      }),

      columnHelper.accessor('rawFile.type', {
        meta: {label: 'Loại file'},
        header: ({column}) => <DataTableColumnHeader column={column} />,
        cell: info => info.renderValue(),
      }),

      columnHelper.display({
        id: 'actions',
        meta: {label: 'Hành động'},
        header: ({column}) => <DataTableColumnHeader column={column} />,
        cell: info => (
          <ActionAndStatusCell info={info} uploadStatus={uploadStatus} options={options} />
        ),
        enableSorting: false,
      }),
    ],
    [options, uploadStatus],
  );

  const table = useReactTable({
    data: files,
    columns: file_preview_columns,
    getCoreRowModel: getCoreRowModel(),
    manualPagination: false,
  });

  return <DataTable table={table} toolbar={false} />;
}

export default DocumentUploadDialog;
